module.exports = __webpack_public_path__ + "static/media/Apple iMac Pro.7978f159.png";